
<template>
  <div id="firstPage">
    <!-- 持仓明细查询 -->
    <div
      class="transcc_new_NewFooter_tabs_mid"
    >
      <div class="transcc_search">
        <!-- <div class="itemSearch">
          <span class="title">商品代码</span>
          <el-select
            v-model="search.commodityCode"
            class="searchSelect"
            size="small"
            filterable
            placeholder="显示全部"
            @change="changeCode"
          >
            <el-option
              v-for="item in commodityOptions"
              :key="item.symbolCode"
              :label="item.commodityCode"
              :value="item.commodityCode"
            >
            </el-option>
          </el-select>
        </div> -->
        <div class="itemSearch">
          <span class="title">商品名称</span>
          <el-select
            v-model="search.symbol"
            popper-class="_ccStyle"
            :popper-append-to-body="false"
            class="searchSelect"
            size="small"
            placeholder="显示全部"
            @change="changeSymbol"
          >
            <el-option
              v-for="item in commodityOptions"
              :key="item.symbolCode"
              :label="item.symbol"
              :value="item.symbol"
            >
            </el-option>
          </el-select>
        </div>
        <div class="itemSearch">
          <span class="title decTitle">买 | 卖</span>
          <el-select
            v-model="search.bsFlag"
            :popper-append-to-body="false"
            class="searchSelect"
            popper-class="_ccStyle"
            size="small"
            placeholder="显示全部"
          >
            <el-option
              v-for="item in bsFlagOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <!-- <div class="itemSearch">
          <span class="title">货值变化</span>
          <el-select
            v-model="search.floatPl"
            class="searchSelect"
            size="small"
            placeholder="显示全部"
          >
            <el-option
              v-for="item in valueOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div> -->
        <div class="itemSearch actionSearch">
          <el-button
            plain
            size="small"
            style="width: 74px;height: 24px;color:#DFDFDF;background: #D94066;font-size:14px;"
            @click="searchData"
          >查询</el-button>
          <el-button
            size="small"
            style="width: 74px;height: 24px;color:#fff;background: #41B37D;font-size:14px;"
            @click="restData"
          >重置</el-button>
        </div>
      </div>
    </div>
    <div
      class="transcc_new_NewFooter_tabs_tabBox"
    >
      <el-table
        class="table_style"
        ref="table"
        :cell-style="{'text-align':'center'}"
        :key="1"
        :data="tableData"
        height="256"
        row-class-name="rowColor"
        style="width: 100%"
        :cell-class-name="directionClass"
        show-summary
        :summary-method="getSummaries"
        @sort-change="sortChange"
        @row-dblclick="openTransDialog"
      >
        <template slot="empty">
          <div v-if="isNetWrong" class="no-datas1"><div class="no-data-img" style="margin: 20px auto 0px; width: 100px; height: 100px;"><img src="../../../assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div></div>
          <div v-else class="no-datas1"><div class="no-data-img" style="margin: 20px auto 0px; width: 100px; height: 100px;"><img src="../../../assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: -15px !important; text-align: center;">暂无数据</div></div>
        </template>
        <!-- <el-table-column
          prop="commodityCode"
          label="商品代码"
          min-width="120"
        >
        </el-table-column> -->
        <el-table-column
          prop="commodityName"
          label="商品名称"
          min-width="70"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="bsFlag"
          label="买 | 卖"
          sortable="custom"
          min-width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="initPrice"
          label="订立价格"
          sortable="custom"
           align="center"
          min-width="100"
        >
          <template slot-scope="scope">
              <!-- :class="
                scope.row.bsFlag == '买入' ? 'red-row' : 'green-row'
              " -->
            <span
            >
              {{ Number(scope.row.initPrice).toFixed(scope.row.priceScale) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="APP_WINNY_NAME !== '楚云农商'"
          prop="stopProfitPrice"
          label="止盈价"
          sortable="custom"
          min-width="100"
           align="center"
        >
          <template slot-scope="scope">
              <!-- :class="
                scope.row.bsFlag == '买入' ? 'red-row' : 'green-row'
              " -->
            <span
            >{{ Number(scope.row.stopProfitPrice).toFixed(scope.row.priceScale) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="APP_WINNY_NAME !== '楚云农商'"
          prop="stopLossPrice"
          label="止损价"
          sortable="custom"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
              <!-- :class="
                scope.row.bsFlag == '买入' ? 'red-row' : 'green-row'
              " -->
            <span
            >{{ Number(scope.row.stopLossPrice).toFixed(scope.row.priceScale) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="initQuantity"
          label="订立数量"
          sortable="custom"
          min-width="110"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.initQuantity }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="quantity"
          label="存货数量"
          min-width="80"
          align="center"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.quantity }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="frozeQuantity"
          label="冻结数量"
          min-width="80"
          align="center"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.frozeQuantity }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="ddQuantity"
          label="抵顶数量"
          min-width="80"
        >
          <template slot-scope="scope">
            <span class="fr yellow-row"> {{ scope.row.ddQuantity }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="holdMargin"
          label="存货订金"
          sortable="custom"
          min-width="120"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.holdMargin }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="holdPl"
          label="货值变化"
          sortable="custom"
          min-width="110"
        >
          <template slot-scope="scope">
            <span
              :class="
                scope.row.textColor
              "
              class="fw fr"
            >
              {{ Number(scope.row.holdPl).toFixed(scope.row.minPriceChange) }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="createTime" label="订立时间" min-width="120"  align="center">
        </el-table-column>
        <el-table-column prop="holdDetailId" label="持仓单号" min-width="80"  align="center">
        </el-table-column>
        <el-table-column prop="index" label="转让" min-width="80" align="center">
          <template slot-scope="scope">
            <span
              v-if="Number(scope.row.availableQuantity)>0"
              class="spotS"
              @click.stop="openTransDialog(scope.row)"
            >转让
            <!-- {{ scope.row.bsFlag=='卖出'?'买入转让':'卖出转让' }} -->
            </span>
          </template>
        </el-table-column>
        <el-table-column v-if="APP_WINNY_NAME !== '楚云农商'" prop="index" label="止盈 | 止损" min-width="100" align="center">
          <template slot-scope="scope">
            <span v-if="Number(scope.row.availableQuantity)>0" class="spotS" @click.stop="openSpotDialog(scope.row)"> 止盈止损</span>
          </template>
        </el-table-column>
        <!-- scope.row.tradeDay < currentDay && -->
        <!-- <el-table-column prop="index" label="交收" min-width="80">
          <template slot-scope="scope">
            <span v-if="Number(scope.row.availableQuantity)>0" class="spotS" @click.stop="gettingData2(scope.row)"> 交收</span>
          </template>
        </el-table-column> -->
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24">
          <el-pagination
            class="pagination_style"
            popper-class="dark_popStyle"
            :current-page="pageData.currentPage"
            :page-size="pageData.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <buy-hold ref="buyHold" @reLoad="searchCurrentData" />
    <transHold ref="transHold" type="1" @reLoad="searchCurrentData" />
    <!-- dialog 交收 -->
    <el-dialog title="现货交收" :visible.sync="dialogFormVisible1" class="stop-profit-loss">
      <!-- <el-row class="zr_dialog_input">
        <el-col :span="6"><div style="line-height:40px">交收价格</div></el-col>
        <el-col :span="18">
          <el-input v-model="transfer1.price" placeholder="交收价格"></el-input>
        </el-col>
      </el-row> -->
      <el-row class="zr_dialog_input">
        <el-col :span="6"><div style="line-height:40px">交收数量</div></el-col>
        <el-col :span="18">
          <el-input v-model="transfer1.quantity" type="number" placeholder="交收数量"></el-input>
        </el-col>
        <el-col :span="24">剩余可现货交收数量{{ oOrderData.availableQuantity }}</el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button class="el-cancel-btn" @click="dialogFormVisible1 = false">取消</el-button>
        <el-button type="primary" class="el-confirm-btn" @click="tackAndLossConfirm2">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/*global http protocol util hqProtocol hqWs*/

import buyHold from './buyHold.vue'
import transHold from './transHold.vue'
import {
  mapGetters
} from 'vuex'
export default {
  components: {
    buyHold,
    transHold
  },
  props: {
    isSpotS: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      table: null,
      dialogFormVisible1: false,
      jsing: false,
      oOrderData: {
        takeProfitPointPriceShow: '',
        stopLossPointPriceShow: ''
      },
      orderNo: null,
      transfer1: {
        // price: '',
        quantity: ''
      },
      // isSpotS: false,
      tableData: [
        // {
        //   availableQuantity: 1,
        //   bsFlag: 'S',
        //   cmarketId: 28,
        //   commodityCode: 'YH2210',
        //   commodityId: 243,
        //   commodityName: '红皮洋葱2210',
        //   createTime: 1639568216000,
        //   curPrice: 4001,
        //   ddQuantity: 0,
        //   dqTime: 9415568216000,
        //   firmId: 5852,
        //   frozeQuantity: 0,
        //   holdDay: 0,
        //   holdDetailId: 692594,
        //   holdMargin: 800.2,
        //   minPriceChange: 1,
        //   offerEndTime: 1661011200000,
        //   pickupStartTime: 1,
        //   quantity: 1,
        //   remainDay: 90000,
        //   singlePrice: 4001,
        //   tradeDay: 20211215,
        //   tradeId: 1273630,
        //   initPrice: 4001,
        //   createTime: 1639568216000,
        //   unitNumeral: 1,
        //   updateTime: 1639568216000
        // }
      ],
      search: {
        commodityCode: null,
        symbol: '全部',
        bsFlag: null,
        floatPl: null
      },
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 6,
        currentPage: 1
      },
      bsFlagOptions: [
        {
          value: null,
          label: '全部'
        },
        {
          value: 'B',
          label: '买入'
        },
        {
          value: 'S',
          label: '卖出'
        }
      ],
      valueOptions: [
          {
            value: '2',
            label: '全部'
          },
        {
          value: '1',
          label: '大于0'
        },
        {
          value: '0',
          label: '等于0'
        },
        {
          value: '-1',
          label: '小于0'
        }
      ],
      timer: null,
      dataArr: '',
      isNetWrong: false,
      HoldDetailListSum: {
        quantity: 0,
        frozeQuantity: 0,
        holdMargin: 0
      },
      reloadTimer: null,
      APP_WINNY_NAME: window.g.APP_WINNY_NAME
    }
  },
  
  updated() {
      this.$nextTick(() => {
          this.$refs.table.doLayout()
      })
  },
  computed: {
    ...mapGetters(['h_holdTime', 'sessionInfoGetter', 'marketDetails', 'commodityStrategyGetter', 'h_sumClosePl', 'marketStatusGetter']),
    commodityOptions() {
      // const commodityList = this.$store.state.hqData.marketDetails.concat({commodityId: null,symbol: '全部'})
      const commodityList = structuredClone(this.$store.state.hqData.marketDetails)
      commodityList.unshift({commodityId: null,symbol: '全部'})
      // return this.$store.state.hqData.marketDetails
      return commodityList
    },
    currentDay() {
      const timer = new Date()
      return Number(util.formatnewDay(timer))
    }

  },
  watch: {
    h_holdTime() {
      this.recursionShowData()
    },
    isSpotS(val) {
      if (val) {
        this.pageData.currentPage = 1
        this.showData()
      }
    }
  },
  mounted() {
    protocol.queryUserHoldingsSubsidiariesNew.data.bsFlag = null
    protocol.queryUserHoldingsSubsidiariesNew.data.commodityId = null
    protocol.queryUserHoldingsSubsidiariesNew.data.holdPlType = null
    this.recursionShowData()
    // this.timer = setInterval(() => {queryUserHoldingsSubsidiariesNew
    //   this.showData()
    // }, window.g.APP_RUNLOOP_TIME ? window.g.APP_RUNLOOP_TIME : 1000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    if (this.reloadTimer) {
      clearInterval(this.reloadTimer)
      this.reloadTimer = null
    }
  },
  methods: {
    // 点击现货买进交收
    gettingData2(obj) {
      // 获取订单信息
      this.oOrderData = obj
      this.orderNo = obj.holdDetailId
      // 显示弹窗
      this.dialogFormVisible1 = true
    },
    // 现货买进交收
    tackAndLossConfirm2() {
      if (this.transfer1.quantity <= 0) {
        this.$message('交收数量需大于0')
        return
      }
      // const that = this
      this.jsing = true
      if (this.transfer1.quantity) {
        protocol.param_addDeliveryDetail.data.holdDetailId = this.orderNo
        // protocol.param_addDeliveryDetail.data.deliveryPrice = this.transfer1.price
        protocol.param_addDeliveryDetail.data.deliveryQuantity = this.transfer1.quantity
        http.gPost(protocol.param_addDeliveryDetail).then(response => {
          this.jsing = false
          if (response.data) {
            const { code, message } = response.data
            if (code == '0') {
              this.$message('成功')
              this.transfer1.price = ''
              this.transfer1.quantity = ''
              this.dialogFormVisible1 = false
            } else {
              this.$message(message)
            }
          }
        })
      } else {
        this.jsing = false
        this.$message('请填写交收数量')
      }
    },
    // 点击止盈止损
    openSpotDialog(obj) {
      this.$refs.buyHold.showDialog(obj)
    },
    // 点击买入卖出转让
    openTransDialog(obj) {
      hqProtocol.param_toporder.symbol = obj.commodityId
      hqWs.send(hqProtocol.param_toporder)
      this.$refs.transHold.showDialog(obj)
    },
    reload() {
      this.recursionShowData()
    },
    changeCode(code) {
      const codeOption = JSON.parse(JSON.stringify(this.commodityOptions))
      codeOption.forEach(element => {
        if (element.commodityCode === code) {
          this.search.commodityCode = element.commodityCode
          this.search.symbol = element.symbol
          this.search.commodityId = element.symbolId
          return
        }
      })
    },
    changeSymbol(symbol) {
      const codeOption = JSON.parse(JSON.stringify(this.commodityOptions))
      codeOption.forEach(element => {
        if(element.symbol == '全部'){
           this.search.commodityId = null
           this.search.symbol = element.symbol
           this.search.commodityCode = null
           return
        }else if (element.symbol === symbol) {
          this.search.symbol = element.symbol
          this.search.commodityCode = element.commodityCode
          this.search.commodityId = element.symbolId
          return
        }
      })
    },
    restData() {
      this.search = {
        commodityCode: null,
        symbol: '全部',
        bsFlag: null,
        floatPl: null,
        commodityId: null
      }
      protocol.queryUserHoldingsSubsidiariesNew.data.bsFlag = null
      protocol.queryUserHoldingsSubsidiariesNew.data.commodityId = null
      protocol.queryUserHoldingsSubsidiariesNew.data.holdPlType = null
      this.pageData.currentPage = 1
      this.showData()
    },
    searchData() {
      protocol.queryUserHoldingsSubsidiariesNew.data.bsFlag = this.search.bsFlag == 'A' ? null : this.search.bsFlag
      protocol.queryUserHoldingsSubsidiariesNew.data.commodityId = this.search.commodityId
      protocol.queryUserHoldingsSubsidiariesNew.data.holdPlType = this.search.floatPl == '2' ? null : this.search.floatPl
      this.pageData.currentPage = 1
      this.showData()
    },
    searchCurrentData() {
      protocol.queryUserHoldingsSubsidiariesNew.data.bsFlag = this.search.bsFlag == 'A' ? null : this.search.bsFlag
      protocol.queryUserHoldingsSubsidiariesNew.data.commodityId = this.search.commodityId
      protocol.queryUserHoldingsSubsidiariesNew.data.holdPlType = this.search.floatPl == '2' ? null : this.search.floatPl
      this.showData()
    },

    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      const that = this
      protocol.queryUserHoldingsSubsidiariesNew.data.page =
          this.pageData.currentPage - 1
      protocol.queryUserHoldingsSubsidiariesNew.data.size =
          '' + this.pageData.pageSize
      // protocol.queryUserHoldingsSubsidiariesNew.data.sort = [{
      //   direction: 'DESC',
      //   property: 'createTime'
      // }]
      // protocol.queryUserHoldingsSubsidiariesNew.data.firmId = this.sessionInfoGetter.firmId
      // protocol.queryUserHoldingsSubsidiariesNew.data.bsFlag = this.search.bsFlag == 'A' ? null : this.search.bsFlag
      // protocol.queryUserHoldingsSubsidiariesNew.data.commodityId = this.search.commodityId
      // protocol.queryUserHoldingsSubsidiariesNew.data.holdPlType = this.search.floatPl == '2' ? null : this.search.floatPl
      // 注释原因是有轮询，上面选择搜索了，但是没有点击搜索按钮
      http.gPost(protocol.queryUserHoldingsSubsidiariesNew).then(response => {
        if (response.data.code != 0) {
          this.isNetWrong = true
          this.$message({ message: response.data.message })
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.dataArr = JSON.stringify(response.data.value.content)
            this.judgeDataType(arr)
            this.HoldDetailListSum = response.data.value?.sumData?.[0] ? response.data.value.sumData[0] : {
              quantity: 0,
              frozeQuantity: 0,
              holdMargin: 0
            }
          }
        }
      }).catch((e) => {
        setTimeout(() => {
          that.showData()
        }, 1000)
      })
    },
    threeTxtColor(price) {
      // 商品价格大于0红色，小于0绿色，等于0灰色
      if (!isNaN(price)) {
        if (price > 0) {
          return 'red-row'
        } else if (price < 0) {
          return 'green-row'
        } else {
          return ''
        }
      }
      return ''
    },
    // 判断数据类型
    judgeDataType(arr) {
      const that = this
      this.each(arr, function(arrIndex) {
        arrIndex.floatPL = 0
        // arrIndex.textColor = ''
        // arrIndex.textColor = that.threeTxtColor(Number(arrIndex.holdPl))
        // const currentTime = arrIndex.pickupStartTime * 24 * 60 * 60 * 1000
        // const timer = util.floatAdd(arrIndex.createTime, currentTime)
        // arrIndex.unterQuantity = util.floatSub(arrIndex.quantity, arrIndex.frozeQuantity)
        // arrIndex.pickupStartTime = util.dateDayFormate(Number(timer))
        arrIndex.availableQuantity = util.floatSub(arrIndex.quantity, arrIndex.frozeQuantity)
        // 判断时间
        // that.modifyTime(arrIndex, 'createTime')
        that.modifyTime(arrIndex, 'createTime')
        // that.modifyTime(arrIndex, 'tradeDay')
        // that.modifyTime(arrIndex, 'pickupStartTime')
        // 判断方向
        that.modifyData(arrIndex, 'bsFlag', 'B', '买入', '卖出')
        // 判断委托状态 1-已委托，2-已成交，3-已撤单，4-部分成交，5-部分成交后撤单
        // const stateList = ['已委托', '已成交', '已撤单', '部分成交', '部分成交后撤单']
        // stateList.forEach((item, index) => {
        //   that.modifyData(arrIndex, 'orderStatus', index + 1, item)
        // })
      })
      this.tableData = arr
    },
    // 排序
    sortChange(column, prop, order) {
      if (column.order == 'ascending') {
        protocol.queryUserHoldingsSubsidiariesNew.data.sort = [{
          'direction': 'ASC',
          'property': ''
        }]
        this.eachSortChange(column.column.property)
      } else if (column.order == 'descending') {
        protocol.queryUserHoldingsSubsidiariesNew.data.sort = [{
          'direction': 'DESC',
          'property': ''
        }]
        this.eachSortChange(column.column.property)
      } else {
        protocol.queryUserHoldingsSubsidiariesNew.data.sort = [{
          'direction': 'DESC',
          'property': 'holdDetailId'
        }]
      }
      protocol.queryUserHoldingsSubsidiariesNew.data.firmId = this.sessionInfoGetter.firmId
      protocol.queryUserHoldingsSubsidiariesNew.data.commodityId = this.search.commodityId
      if (column.column) {
        http.gPost(protocol.queryUserHoldingsSubsidiariesNew).then(response => {
          if (response.data.code != 0) {
            this.isNetWrong = true
            this.$message({ message: response.data.message })
          } else {
            this.isNetWrong = false
          }
          if (response.data) {
            if (response.data && response.data.code == '0') {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
              this.HoldDetailListSum = response.data.value?.sumData?.[0] ? response.data.value.sumData[0] : {
                quantity: 0,
                frozeQuantity: 0,
                holdMargin: 0
              }
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      return (protocol.queryUserHoldingsSubsidiariesNew.data.sort[0].property = str)
    },
    // 递归订单展示
    recursionShowData() {
      this.showData()
    },
    // 合计
    getSummaries(param) {
      const { columns } = param
      const sums = []
      const that = this
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 5) { // 存货数量
          sums[index] = that.HoldDetailListSum.quantity
          return
        }
        if (index === 6) { // 冻结数量
          sums[index] = that.HoldDetailListSum.frozeQuantity
          return
        }
        // if (index === 7) { // 抵顶数量
        //   sums[index] = that.HoldDetailListSum.ddQuantity
        //   return
        // }
        if (index === 7) { // 存货订金
          sums[index] = that.HoldDetailListSum.holdMargin.toFixed(2)
          return
        }
        // if (index === 12) { // 货值变化
        //   sums[index] = that.HoldDetailListSum.holdPl // that.HoldDetailListSum.sumClosePl
        //   // if (that.marketStatusGetter.status == 'P' || that.marketStatusGetter.status == 'T') {
        //   //   if (protocol.queryUserHoldingsSubsidiariesNew.data.bsFlag) {
        //   //     sums[index] = '--'
        //   //   } else {
        //   //     sums[index] = that.h_sumClosePl // that.HoldDetailListSum.sumClosePl
        //   //   }
        //   // } else {
        //   //   sums[index] = 0
        //   // }
        //   setTimeout(() => {
        //     const footerWrap = document.getElementsByClassName('el-table__footer-wrapper')[0]
        //     const lastCell = footerWrap.getElementsByTagName('td')[12] // 给货值变化颜色
        //     const cell = lastCell.getElementsByClassName('cell')[0]
        //     if (!isNaN(sums[index])) {
        //       if (sums[index] > 0) {
        //         cell.setAttribute('class', 'cell red-row')
        //       } else if (sums[index] < 0) {
        //         cell.setAttribute('class', 'cell green-row')
        //       } else {
        //         cell.setAttribute('class', 'cell white-row')
        //       }
        //     }
        //   }, 100)
        //   return
        // }
        sums[index] = ''
      })
      return sums
    },
    // 单元格颜色
    directionClass(row, column, rowIndex, columnIndex) {
      // 根据字段改变样式
      if (row.columnIndex == 1) {
        return this.setStrClass(row.row.bsFlag, '卖出', 'dropColor', 'increaseColor')
      }
    }
  }

}
</script>
<style lang="scss" scoped>
/deep/ .dropColor > *{
  color: #41B37D !important;
}
//el-selecl 
::v-deep .el-input--small .el-input__icon{
  line-height: 26px;
}
::v-deep .el-select-dropdown{
  transform-origin: center top !important; 
}
::v-deep .el-select-dropdown__list{
  width: 156px !important;
}
.el-select-dropdown__item.selected{
  color: #989898
}
</style>
<style lang="scss" scoped>

//el-pagination 样式位于NewFooter组件

//el-table
/deep/ .el-table__row{
  height: 32px;
}
// /deep/ .el-table__body-wrapper{
//   height: 128px !important;
// }
/deep/ .el-table__footer-wrapper .el-table__footer{
    height: 36px !important;
}
/deep/ .el-table td div{
  text-align: center;
  color: #dfdfdf;
}
/deep/ .el-table__footer-wrapper .el-table td div{
  text-align: center;
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td{
  background-color: #222324 !important;
}
/deep/ .el-table table tr{
   background-color: #161719;
}
</style>
<style lang="scss" scoped>
/deep/ .el-table tr{
  background: #161719 !important;
}
.transcc_search{
  // padding-left: 30px;
  display:flex;
  justify-content: flex-start;
  align-items: center;
  margin: 3px 0;
  .itemSearch{
    position: relative;
    display:flex;
    justify-content: flex-start;
    align-items: center;
    margin: 12px 30px 12px 0;
    .title{
      width:60px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.6);
    }
    .searchSelect{
      width:158px;
      background-color: transparent;
    }
    .decTitle{
      width: 44px;
    }
  }
  /deep/ .el-input.is-focus .el-input__inner{
         border-color: #fff !important;
  }
  /deep/  .el-input__inner{
        height: 26px !important;
        background-color: transparent;
        border-color: rgba($color: #fff, $alpha: 0.3);
      }
   /deep/.el-button{
     border:none;
     border-radius: 15px;
     padding: 5px 15px !important;
   }
    /deep/.el-button span {
      color: #fff;
    }
 /deep/.currentQuery{
    background-color:#1989fa;
  }
  /deep/.queryBtn{
    background-color:#fff;
  }

  /deep/.queryBtn span{
    color:#1989fa;
  }
  /deep/.currentQuery span{
    color: #fff;
  }
  .actionSearch{
    margin-left:10px;
  }
}

 .transcc_query_search {
        margin-top: 16px;
        .el-button{
          width:52px;
          height: 32px;
          background-color:transparent;
          border: 1px solid #363F66;
        }
  }
  .transcc_new_NewFooter_tabs_tabBox {
    width: 100%;
    .transcc_new_NewFooter_tabs_tabBox_head {
      width: 100%;
      display: flex;
      // justify-content: space-around;
      align-items: center;
      height: 60px;
      .tab_head_item {
        width: 130px;
        margin-left: 10px;
        display: flex;
        align-items: center;
        height: 14px;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.6);
        line-height: 14px;
      }
    }
    .borderline {
      width: 100%;
      height: 1px;
      background: linear-gradient(
        45deg,
        rgba(94, 101, 146, 0.4) 0%,
        #464c74 53%,
        rgba(48, 53, 89, 0.4) 100%
      );
    }
  }

</style>
